const accordionItems = document.querySelectorAll('.js-wp-block-waico-accordion__target');
accordionItems.forEach((accordion) => {
	const trigger = accordion.querySelector('.js-wp-block-waico-accordion__trigger');
	if (trigger) {
		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			event.target.closest('.wp-block-waico-accordion').classList.toggle('is-open');
		});
	}
});
